import { useCallback, useEffect, useMemo, useState } from 'react'

export interface UseCounterOptions {
  incrementCallback?: (cb: (newValue: number) => void) => void
  decrementCallback?: (cb: (newValue: number) => void) => void
}

export function useCounter(
  initialValue?: number,
  options: UseCounterOptions = {}
) {
  const [count, setCount] = useState(initialValue || 0)

  const incrementCallback = useCallback(() => {
    if (options.incrementCallback) {
      options.incrementCallback(value => setCount(value + 1))
      return
    }

    setCount(x => x + 1)
  }, [])

  const decrementCallback = useCallback(() => {
    if (options.decrementCallback) {
      options.decrementCallback(value => setCount(value - 1))
      return
    }

    setCount(x => x - 1)
  }, [])

  useEffect(() => {
    setCount(initialValue || 0)
  }, [initialValue])

  const callbacks = useMemo(
    () => ({
      increment: incrementCallback,
      decrement: decrementCallback,
      reset: () => setCount(initialValue || 0)
    }),
    [initialValue]
  )

  return [
    count,
    {
      set: setCount,
      ...callbacks
    }
  ] as const
}
